<script>
export default {
  props: {
    couponName: {
      type: String,
      required: false,
      default: ""
    }
  },

  computed: {
    url() {
      return (
        "https://api.whatsapp.com/send?text=Acabei%20de%20contratar%20uma%20diarista%20pela%20Donamaid.%20Use%20o%20cupom%20de%20desconto%20" +
        this.couponName +
        "%20e%20agende%20uma%20para%20você%20também!%21%20www.donamaid.com"
      );
    }
  }
};
</script>

<template>
  <div class='coupon-container'>
    <h2>Ei, você ai, não guarde esse desconto só para você!</h2>
    <h3>Clica aqui embaixo e compartilha com os amigos.</h3>

    <a
      :href="url"
      class="btn btn-purple"
      target="_blank"
      rel="noopener noreferrer"
    >
      Compartilhar cupom
      <img src="\static\whatsapp_logo_purple.svg" class="ml-10" />
    </a>
  </div>
</template>

<style scoped>
.coupon-container {
  max-width: 100%;
  text-align: center;
  color: #fcfafd;
}

.btn-purple {
  background: #fcfafd;
  width: fit-content;
  color: #c400ff;
  text-transform: uppercase;
  font-weight: 600;
  margin: 0 auto;
  border: solid 1px #c400ff;
  border-radius: 4px;
  box-shadow: 0px 0px 15px #e300e3;
}

img {
  color: #c400ff;
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Checkout/CouponCard.vue